/**
 * Flows tints (Figma ↳ Flows): each node category and each edge data type
 * takes one categorical chart colour - solid for dots, strokes and icons,
 * 14% for fills. Class strings are spelled out so Tailwind sees them.
 */
export type FlowTint =
  'sky' | 'ochre' | 'violet' | 'magenta' | 'orange' | 'teal' | 'olive' | 'yellow';

export const FLOW_TINTS: Record<
  FlowTint,
  { soft: string; solid: string; text: string; ring: string }
> = {
  sky: {
    soft: 'bg-chart-cat-2/14',
    solid: 'bg-chart-cat-2',
    text: 'text-chart-cat-2',
    ring: 'inset-ring-chart-cat-2',
  },
  ochre: {
    soft: 'bg-chart-cat-8/14',
    solid: 'bg-chart-cat-8',
    text: 'text-chart-cat-8',
    ring: 'inset-ring-chart-cat-8',
  },
  violet: {
    soft: 'bg-chart-cat-3/14',
    solid: 'bg-chart-cat-3',
    text: 'text-chart-cat-3',
    ring: 'inset-ring-chart-cat-3',
  },
  magenta: {
    soft: 'bg-chart-cat-5/14',
    solid: 'bg-chart-cat-5',
    text: 'text-chart-cat-5',
    ring: 'inset-ring-chart-cat-5',
  },
  orange: {
    soft: 'bg-chart-cat-4/14',
    solid: 'bg-chart-cat-4',
    text: 'text-chart-cat-4',
    ring: 'inset-ring-chart-cat-4',
  },
  teal: {
    soft: 'bg-chart-cat-7/14',
    solid: 'bg-chart-cat-7',
    text: 'text-chart-cat-7',
    ring: 'inset-ring-chart-cat-7',
  },
  olive: {
    soft: 'bg-chart-cat-1/14',
    solid: 'bg-chart-cat-1',
    text: 'text-chart-cat-1',
    ring: 'inset-ring-chart-cat-1',
  },
  yellow: {
    soft: 'bg-chart-cat-6/14',
    solid: 'bg-chart-cat-6',
    text: 'text-chart-cat-6',
    ring: 'inset-ring-chart-cat-6',
  },
};

/** Figma "Category" on Library node: where content comes from … where it goes. */
export type FlowCategory =
  'starter' | 'filter' | 'generate' | 'edit' | 'experiment' | 'guardrail' | 'output';

export const CATEGORY_TINT: Record<FlowCategory, FlowTint> = {
  starter: 'sky',
  filter: 'ochre',
  generate: 'violet',
  edit: 'magenta',
  experiment: 'orange',
  guardrail: 'teal',
  output: 'olive',
};

/** Figma "Type" on Data type chip: what travels along an edge. */
export type FlowDataType =
  'source' | 'blueprint' | 'script' | 'clip' | 'reel' | 'carousel' | 'image' | 'variant';

export const DATA_TYPE_TINT: Record<FlowDataType, FlowTint> = {
  source: 'sky',
  blueprint: 'ochre',
  script: 'violet',
  clip: 'magenta',
  reel: 'olive',
  carousel: 'teal',
  image: 'yellow',
  variant: 'orange',
};
